import { render } from "./LibraryLoan.vue?vue&type=template&id=20e608be&scoped=true"
import script from "./LibraryLoan.vue?vue&type=script&lang=js"
export * from "./LibraryLoan.vue?vue&type=script&lang=js"

import "./LibraryLoan.vue?vue&type=style&index=0&id=20e608be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e608be"]])

export default __exports__